import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(_callee);

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { take, put, call, select } from 'redux-saga/effects';
import logger from '../../../logger/logger';
import confirmAppNavigation from '../../../confirm-app-navigation/confirm-app-navigation';
import { getNavigation } from '../../selectors';
import * as actions from '../actions';
export default function _callee() {
  var navigation, failureReason;
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 19;
            break;
          }

          _context.prev = 1;
          _context.next = 4;
          return take(actions.LOGOFF_REQUEST_CONFIRMATION);

        case 4:
          _context.next = 6;
          return select(getNavigation);

        case 6:
          navigation = _context.sent;
          _context.next = 9;
          return call(confirmAppNavigation, navigation.toJS());

        case 9:
          _context.next = 11;
          return put(actions.showLogoffConfirmation());

        case 11:
          _context.next = 17;
          break;

        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](1);
          failureReason = _context.t0.failureReason;
          logger.debug(failureReason);

        case 17:
          _context.next = 0;
          break;

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 13]]);
}